import { importModules } from "@/util";

const context = require.context("./modules", true, /\.js$/);

const modules = importModules(context, (key, item) => {
    // extract the module subdirectory name
    const name = key.replace(/^.*(\\|\/|:)|\..*$/g, "");

    return {
        [name]: Object.assign(
            {
                namespaced: true
            },
            item.default
        )
    };
});

export default {
    modules,
    strict: process.env.NODE_ENV === "development"
};
